import { flow } from 'lodash';
import { NAME } from './payment.constant';

import { selectPaymentState } from '../receipts.selector';

const selectState = (state) => state[NAME];
export const selectHistoryState = flow(selectPaymentState, selectState);

const selectLoadingKey = (state) => state.loading;
const selectErrorKey = (state) => state.error;
const selectDataKey = (state) => state.data;

export const selectError = flow(selectHistoryState, selectErrorKey);
export const selectLoading = flow(selectHistoryState, selectLoadingKey);
export const selectData = flow(selectHistoryState, selectDataKey);
